/**
 * Collection Chat Types
 * Represents conversations and messages within a SessionCollection
 */

export enum CollectionChatRole {
  User = 0,
  Assistant = 1,
  System = 2,
  Analysis = 3
}

export interface CollectionChatMessageChunk {
  id: string;
  sequence: number;
  chunkType: 'text' | 'tool_call' | 'tool_result';
  content: string;
  toolName?: string | null;
  toolArgs?: string | null;
  toolResult?: string | null;
  timestamp: string;
}

export interface CollectionChatMessage {
  id: string;
  userId?: string | null;
  role: CollectionChatRole;
  content: string;
  timestamp: string;
  chunks?: CollectionChatMessageChunk[];
}

export interface CollectionConversation {
  id: string;
  title: string;
  description?: string | null;
  threadId?: string | null;
  createdByUserId: string;
  createdAt: string;
  lastMessageAt: string;
  messageCount: number;
  messages: CollectionChatMessage[];
}

export interface CreateConversationInput {
  sessionCollectionId: string | null; // Nullable for global chats
  title: string;
  description?: string | null;
  threadId?: string | null;
}

export interface SendMessageInput {
  conversationId: string;
  userId?: string | null;
  role: CollectionChatRole;
  content: string;
}

export interface CreateConversationResult {
  success: boolean;
  message?: string | null;
  conversation?: CollectionConversation | null;
}

export interface SendMessageResult {
  success: boolean;
  message?: string | null;
  chatMessage?: CollectionChatMessage | null;
}
